// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { hideElementOnPrint, xScreen } from "@conklin/XDL/Utilities";
import { cookiePrivacyPolicyPopupStyles } from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import { css } from "styled-components";

cookiePrivacyPolicyPopupStyles.drawer = {
    position: "bottom",
    size: 100,
    cssOverrides: {
        drawerTitle: css`
            display: none;
        `,
        drawerContent: css`
            padding: 16px;
            margin: 0 auto;
            width: 100%;
        `,
        drawerBody: css`
            top: auto;
            bottom: 0;
            justify-content: center;
            ${hideElementOnPrint}

            ${xScreen("lte", "md")} {
                && {
                    display: flex;
                }
            }

            ${xScreen("lte", "sm")} {
                && {
                    height: 145px;
                }
            }
        `,
        scrim: css`
            top: auto;
            bottom: 0;
        `,
    },
    closeButtonProps: {
        css: css`
            display: none;
        `,
    },
    enableClickThrough: true,
};

cookiePrivacyPolicyPopupStyles.messageGridItem = {
    width: [12, 6, 8, 8, 8],
};

cookiePrivacyPolicyPopupStyles.acceptGridItem = {
    width: [12, 3, 2, 2, 2],
};

cookiePrivacyPolicyPopupStyles.closeGridItem = {
    width: [12, 3, 2, 2, 2],
};
